import ApiService from "@/core/services/ApiService";

class StudentService {

    //obtener la lista de studiantes
    public static getData(params) {
        ApiService.setHeader()
        return ApiService.post('api/students',params)
    }
}

export default StudentService;